// Kort "magisk" cue efter fortælling-oplæsning — signal til at skrive.

import { primeSuccessChime } from './successChime';

let sharedCtx: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (sharedCtx) return sharedCtx;
  if (typeof window === 'undefined') return null;
  try {
    const Ctx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!Ctx) return null;
    sharedCtx = new Ctx();
  } catch {
    sharedCtx = null;
  }
  return sharedCtx;
}

function playTone(
  ctx: AudioContext,
  frequency: number,
  startAt: number,
  peakGain: number,
  durationSec: number,
): void {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'triangle';
  osc.frequency.value = frequency;
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(peakGain, startAt + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + durationSec);
  osc.connect(gain).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + durationSec + 0.02);
}

/** Shimmer — højere toner efter TTS, ~220 ms. */
export function playStoryMagicCue(): void {
  primeSuccessChime();
  const ctx = getContext();
  if (!ctx) return;
  void ctx.resume().catch(() => {});
  const t0 = ctx.currentTime;
  playTone(ctx, 880, t0, 0.1, 0.07);
  playTone(ctx, 1174.66, t0 + 0.06, 0.08, 0.09);
  playTone(ctx, 1567.98, t0 + 0.12, 0.06, 0.1);
}
